import { Injectable, signal, WritableSignal } from '@angular/core';

@Injectable({
    providedIn: 'root',

})
export class RedirectionService {
    solution: WritableSignal<number> = signal(0);
    contactUs: WritableSignal<number> = signal(0);



    handler_scroll(_scrollElement: any) {
        let scrollContent = document.getElementById(_scrollElement);
        let scrollValue = scrollContent?.getBoundingClientRect().y;
        if (scrollValue)
            window.scrollTo({ top: scrollValue, behavior: 'smooth' })
    }
}